import styled from "styled-components";
// CONSTANTS
import { COLORS } from "Styles/Constants";

/**
 * Full-viewport, branded loading screen shown while a lazily code-split
 * game bundle is being downloaded/evaluated.
 *
 * It is `position: fixed` and fully covers the viewport with the app's
 * dark brand background colour, so the user NEVER sees the default white
 * body while the game chunk is in flight. The Science background image is
 * layered on top (via <LazyImage />) for a seamless hand-off to the game
 * screen, which uses the exact same background.
 *
 * Explicit top/right/bottom/left are used (instead of the `inset`
 * shorthand) for maximum cross-browser support (older Safari / mobile).
 */
export const LoaderWrapper = styled.div`
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	width: 100%;
	height: 100%;
	min-height: 100vh;
	z-index: 9999;
	overflow: hidden;
	position: fixed;
	display: flex;
	align-items: center;
	justify-content: center;
	/* Solid brand backdrop paints instantly — no white flash even before
	   the background image has decoded. */
	background-color: ${COLORS.BLUE_BACKGROUND};

	.background-image {
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 0;
		overflow: hidden;
		position: absolute;
	}

	.loader-content {
		z-index: 1;
		display: flex;
		position: relative;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}

	.spinner {
		color: ${COLORS.WHITE};
	}

	.loader-text {
		margin-top: 18px;
		color: ${COLORS.WHITE};
		font-size: 16px;
		letter-spacing: 1px;
		text-transform: uppercase;
	}
`;
